import React from 'react';
import moment, { DurationInputArg2 } from 'moment';
import {
  Resources,
  InexactDurationUnit,
  RequestFundingType,
} from '@erecruit/types';
import { Intl } from '@erecruit/core';

export const WizardContext = React.createContext<AddNewPositionWizardFields>({
  general: { positionTitle: '' },
  location: { facilityDepartments: [] },
  schedule: {},
  billing: {},
  additionalInfo: {},
  review: {},
});

export interface AddNewPositionWizardFields {
  general: {
    numberOfPositions?: number;
    positionDescription?: string;
    positionTitle?: string;
    positionType?: number;
    folderGroup?: string;
  };
  location: {
    worksiteAddress?: number;
    facilityDepartments?: number[];
    workFromHome?: boolean;
  };
  schedule: {
    durationAmount?: number;
    durationUnit?: InexactDurationUnit;
    estimatedStartDate?: moment.Moment;
    estimatedEndDate?: moment.Moment;
    startTime?: moment.Moment;
    endTime?: moment.Moment;
    shiftTypeId?: number;
  };
  billing: {
    targetBillRate?: number;
    estimatedSpend?: number;
    minimumBillRate?: number;
    maximumBillRate?: number;
    requestFunding?: RequestFundingType;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalInfo: Record<string, any>;
  review: {
    positionCreationReason?: string;
  };
}

export type PositionFieldSection =
  | 'general'
  | 'location'
  | 'schedule'
  | 'billing'
  | 'review';

export enum FormFieldType {
  Boolean,
  Date,
  MultiSelect,
  Number,
  RichText,
  SingleSelect,
  Text,
  TextArea,
  InputNumber,
  Checkbox,
  Currency,
  Time,
}

// extended backend type with form field type and section because
// we need to manually map the fields to section and form field
export interface PositionField extends Resources.TemplateField {
  formFieldType: FormFieldType;
  section: PositionFieldSection;
  data?: unknown[];
}

export interface PositionTemplate extends Resources.PositionTemplateDetails {
  fields: PositionField[];
}

export interface ResourceFilter {
  ids?: number[];
  searchTerm?: string;
  companyIds?: number[];
}

export interface DurationUnit {
  value: InexactDurationUnit;
  resolution: DurationInputArg2;
  messageId: Intl.LocalizationKeysArray;
}
